import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue";
var _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", {
  "class": "mb-8 text-3xl font-bold"
}, "Resource Mapping", -1);
var _hoisted_2 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6 px-6 py-4 w-full"
};
var _hoisted_3 = {
  key: 0,
  "class": "py-4 px-2"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Filter by reporting to", -1);
var _hoisted_5 = [_hoisted_4];
var _hoisted_6 = /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "block text-gray-700 font-bold"
}, "Mapping status")], -1);
var _hoisted_7 = /*#__PURE__*/_createElementVNode("td", {
  "class": "py-4 px-2"
}, [/*#__PURE__*/_createElementVNode("label", {
  "class": "ml-2 block text-gray-700 font-bold"
}, "Search")], -1);
var _hoisted_8 = {
  key: 0,
  "class": "px-2 pb-4"
};
var _hoisted_9 = {
  "class": "px-2 pb-4"
};
var _hoisted_10 = {
  "class": "px-2 pb-4"
};
var _hoisted_11 = {
  "class": "w-full flex items-center rounded-md border border-resborder h-10 m-2"
};
var _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  "class": "res-btn-icon"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: "/images/res-search.svg"
})], -1);
var _hoisted_13 = {
  "class": "bg-white rounded-md shadow overflow-x-auto mb-6"
};
var _hoisted_14 = ["onClick"];
var _hoisted_15 = {
  "class": "flex justify-end"
};
var _hoisted_16 = {
  "class": "m-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  var _component_el_option = _resolveComponent("el-option");
  var _component_el_select = _resolveComponent("el-select");
  var _component_el_switch = _resolveComponent("el-switch");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  var _component_el_table_column = _resolveComponent("el-table-column");
  var _component_el_table = _resolveComponent("el-table");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _component_el_pagination = _resolveComponent("el-pagination");
  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_Head, {
    title: "Resource Mapping"
  }), _hoisted_1, _createElementVNode("table", _hoisted_2, [_createElementVNode("tr", null, [$props.userType == 'admin' ? (_openBlock(), _createElementBlock("td", _hoisted_3, _hoisted_5)) : _createCommentVNode("", true), _hoisted_6, _hoisted_7]), _createElementVNode("tr", null, [$props.userType == 'admin' ? (_openBlock(), _createElementBlock("td", _hoisted_8, [_createVNode(_component_el_select, {
    modelValue: $data.reportingTo,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.reportingTo = $event;
    }),
    filterable: "",
    onChange: _cache[1] || (_cache[1] = function ($event) {
      return $options.getUserList(true);
    }),
    clearable: ""
  }, {
    "default": _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.managerList, function (m, m_key) {
        return _openBlock(), _createBlock(_component_el_option, {
          value: m.user_id,
          label: m.name
        }, null, 8, ["value", "label"]);
      }), 256))];
    }),
    _: 1
  }, 8, ["modelValue"])])) : _createCommentVNode("", true), _createElementVNode("td", _hoisted_9, [_createVNode(_component_el_switch, {
    modelValue: $data.mappingStatus,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $data.mappingStatus = $event;
    }),
    "active-text": "Mapped",
    "inactive-text": "Unmapped",
    onChange: _cache[3] || (_cache[3] = function ($event) {
      return $options.getUserList(true);
    }),
    "class": "m-2"
  }, null, 8, ["modelValue"])]), _createElementVNode("td", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createVNode(_component_el_input, {
    "class": "w-full focus:shadow focus:outline-none border-none rounded-md text-sm",
    modelValue: $data.searchValue,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
      return $data.searchValue = $event;
    }),
    placeholder: "search",
    "suffix-icon": "Search",
    clearable: true,
    onChange: $options.searchName
  }, null, 8, ["modelValue", "onChange"])])])])]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingMapping,
    animated: "",
    count: 9
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_table, {
        data: $data.resourceList,
        style: {
          "width": "100%"
        }
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name"
          }), _createVNode(_component_el_table_column, {
            prop: "email",
            label: "Email"
          }), _createVNode(_component_el_table_column, {
            label: "Title"
          }, {
            "default": _withCtx(function (scope) {
              return [_createVNode(_component_el_select, {
                modelValue: scope.row.title,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.title = $event;
                }
              }, {
                "default": _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.resourceTypes, function (res, key) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: res,
                      label: key
                    }, null, 8, ["value", "label"]);
                  }), 256))];
                }),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Reporting To"
          }, {
            "default": _withCtx(function (scope) {
              return [_createVNode(_component_el_select, {
                modelValue: scope.row.report_to,
                "onUpdate:modelValue": function onUpdateModelValue($event) {
                  return scope.row.report_to = $event;
                },
                filterable: ""
              }, {
                "default": _withCtx(function () {
                  return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.managerList, function (m, m_key) {
                    return _openBlock(), _createBlock(_component_el_option, {
                      value: m.user_id,
                      label: m.name
                    }, null, 8, ["value", "label"]);
                  }), 256))];
                }),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue"])];
            }),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "Save",
            width: "100"
          }, {
            "default": _withCtx(function (scope) {
              return [_createElementVNode("button", {
                onClick: function onClick($event) {
                  return $options.saveData(scope.row);
                },
                "class": "btn-primary-smaller"
              }, "Save", 8, _hoisted_14)];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["data"])];
    }),
    _: 1
  }, 8, ["loading"]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createVNode(_component_el_skeleton, {
    loading: $data.isLoadingPaginate,
    animated: "",
    count: 1
  }, {
    template: _withCtx(function () {
      return [_createElementVNode("div", null, [_createVNode(_component_el_skeleton_item, {
        variant: "h3"
      })])];
    }),
    "default": _withCtx(function () {
      return [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        total: $data.totalCount,
        "current-page": $data.currentPage,
        onCurrentChange: $options.pageChange
      }, null, 8, ["total", "current-page", "onCurrentChange"])];
    }),
    _: 1
  }, 8, ["loading"])])])])]);
}